/**
 * The one verification of the tab Service and the project field of its state. The API names no
 * type (its state actions take none); the key only binds the generic blocks to the state field.
 */
export const SERVICE_VERIFICATION_TYPES = ['SERVICE'];

export const STATE_TYPE_BY_SERVICE_VERIFICATION_TYPE = {
  SERVICE: 'serviceVerificationState',
};
